import loadable from '@loadable/component';
import { find as findUnitizers } from 'redux/modules/unitizers';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'redi... Remove this comment to see the full error message
import provideHooks from 'redial/lib/provideHooks';
import LoadingComponent from 'components/Loaders/LoadingComponent';

const BarCodeLabelUnitizerLoadable = loadable(
  () => import(/* webpackChunkName: 'admin-BarCodeLabelUnitizer' */ './BarCodeLabelUnitizer'),
  {
    fallback: <LoadingComponent />,
  }
);

const BarCodeLabelUnitizer = (prop: any) => <BarCodeLabelUnitizerLoadable {...prop} />;

export default provideHooks({
  fetch: async ({ params, store: { dispatch } }: any) => {
    const promises = [];

    promises.push(
      dispatch(
        findUnitizers(`unitizerId-${params.id}`, {
          query: {
            $paginate: false,
            uid: params.id,
            include: ['AccountExtended', 'Label', 'Service', 'ServiceOption', 'ParcelComplete'],
          },
        })
      ).catch(console.error)
    );

    await Promise.all(promises);
  },
})(BarCodeLabelUnitizer);
